module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-17-c43b6788186f7fbcf8447a26ead4f1e5.png";